import API from "../../../context/API";

export class EmailTemplateApi {
    static baseURL = '/admin/email-templates';

    static async getAllTemplates(params = {}) {
        const token = localStorage.getItem("access_token");
        const response = await API.get(this.baseURL, {
            headers: {Authorization: `Bearer ${token}`},
            params,
        });
        return response.data;
    }

    static async getTemplateById(id) {
        const token = localStorage.getItem("access_token");
        const response = await API.get(`${this.baseURL}/${id}`, {
            headers: {Authorization: `Bearer ${token}`},
        });
        return response.data;
    }

    static async createTemplate(templateData) {
        const token = localStorage.getItem("access_token");
        const response = await API.post(this.baseURL, templateData, {
            headers: {Authorization: `Bearer ${token}`},
        });
        return response.data;
    }

    static async updateTemplate(id, templateData) {
        const token = localStorage.getItem("access_token");
        const response = await API.put(`${this.baseURL}/${id}`, templateData, {
            headers: {Authorization: `Bearer ${token}`},
        });
        return response.data;
    }

    static async deleteTemplate(id) {
        const token = localStorage.getItem("access_token");
        const response = await API.delete(`${this.baseURL}/${id}`, {
            headers: {Authorization: `Bearer ${token}`},
        });
        return response.data;
    }

    static async duplicateTemplate(id, newName) {
        const token = localStorage.getItem("access_token");
        const response = await API.post(`${this.baseURL}/${id}/duplicate`,
            {name: newName},
            {headers: {Authorization: `Bearer ${token}`}}
        );
        return response.data;
    }

    static async setAsDefault(id) {
        const token = localStorage.getItem("access_token");
        const response = await API.put(`${this.baseURL}/${id}/set-default`, {}, {
            headers: {Authorization: `Bearer ${token}`},
        });
        return response.data;
    }

    static async sendTestEmail(id, testData) {
        const token = localStorage.getItem("access_token");
        const response = await API.post(`${this.baseURL}/${id}/test`, testData, {
            headers: {Authorization: `Bearer ${token}`},
        });
        return response.data;
    }

    static async getTemplateStats() {
        const token = localStorage.getItem("access_token");
        try {
            const response = await API.get(`${this.baseURL}/stats`, {
                headers: {Authorization: `Bearer ${token}`},
            });
            return response.data;
        } catch (error) {
            console.error('Stats API Error:', error);
            // Re-throw the error so the calling function can handle it
            throw error;
        }
    }

    static async getTemplateTypes() {
        const token = localStorage.getItem("access_token");
        const response = await API.get(`${this.baseURL}/types`, {
            headers: {Authorization: `Bearer ${token}`},
        });
        return response.data;
    }

    static async getTemplateVariables(type) {
        const token = localStorage.getItem("access_token");
        const response = await API.get(`${this.baseURL}/variables/${type}`, {
            headers: {Authorization: `Bearer ${token}`},
        });
        return response.data;
    }

    static async getTemplateByType(type, useDefault = true) {
        const token = localStorage.getItem("access_token");
        try {
            const response = await API.get(`${this.baseURL}/type/${type}`, {
                headers: {Authorization: `Bearer ${token}`},
                params: {useDefault},
            });
            return response.data;
        } catch (error) {
            // Handle specific error cases
            if (error.response?.status === 400) {
                throw new Error(error.response.data.message || 'No template found for this type');
            }
            throw error;
        }
    }
}
